import {
  setToken,
  getToken,
  removeToken,
  setUserData,
  removeUserData,
  setRefresh,
  removeSidebar
} from "../../utils/auth";
import {
  refreshToken,
  login,
  logOutUser,
  getAuthUserData,
  getUserAuth
} from "../../api/auth";

export default {
  loginJWT({commit}, data) {
    return new Promise((resolve, reject) => {
      // removeToken()
      login(data)
        .then(response => {
          // getUserAuth().then(res => {
          //   console.log(res)
          // })

          setUserData(response.data)

          var token = JSON.parse(response.data.tokens);
          if (token) {
            // закидываю данные в сторе

            // console.log("commit", response.data);
            commit("UPDATE_USER_INFO", response.data, {root: true});
            setToken(token.access);
            setRefresh(token.refresh);
            // commit("SET_AUTH_USER_PROFILE",response.data.userData)
            resolve(response);
          } else {
            reject({message: "Wrong Email or Password"});
          }
        })
        .catch(err => {
          // console.log(err)
          reject(err);
        });
    });
  },

  fetchAccessToken() {
    return new Promise((resolve, reject) => {
      refreshToken()
        .then(response => {
          setToken(response.data.access);
          setRefresh(response.data.refresh);
          resolve(response);
        })
        .catch(err => {
          // console.log(err)
          reject(err);
        });
    });
  },
  JWTLogout({commit}) {
    //   removeToken()
    return new Promise((resolve, reject) => {
      logOutUser()
        .then(res => {

          // commit('REMOVE_USER_DATA')
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
      localStorage.clear()
      removeToken();
      removeUserData();
      // localStorage.removeItem("sidebar");
    });
  },
  fetchUserData({commit}) {
    return new Promise((resolve, reject) => {
      getAuthUserData()
        .then(res => {
          commit("SET_AUTH_USER_PROFILE", res.data);
          setUserData(res.data);
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  changeUserLang({commit}, data) {
    commit("CHANGE_USER_LANG", data);
  }
};
